import { Line } from 'react-chartjs-2';
import { Chart } from 'chart.js';
import React from 'react';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { withRouter } from '../../../services/withRoute';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { ReactComponent as FullScreen } from '../../../assets/svg/expand2.svg';
import moment from 'moment';
import { gql } from '@apollo/client';
import _ from 'lodash';
import '../../../assets/scss/dashboard.scss';
//import DashboardGraphModal from './DashboardGraphModal';

const getWorkspaces = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
			id
			vendorId
			businessName
			isSuperHuemn
		}
	}
`;

const getMonthlyOverview = gql`
	query MonthlyOverview(
		$workspaceIds: [String]
		$filters: monthlyChartFilters
		$mcMonthlySummaryWorkspaceIds2: [String]
		$mcMonthlySummaryFilters2: MonthlySummaryFiltersInput
	) {
		monthlyOverview(filters: $filters, workspaceIds: $workspaceIds) {
			events {
				date
				eventType
				totalEvents
			}
			expenses {
				date
				approvedExpense
				unApprovedExpense
			}
			requirement {
				date
				roles {
					count
					role
					subRole
				}
			}
			additionalServices {
				date
				type
				count
			}
			crew {
				assignedCrewCount
				unAssignedCrewCount
				date
			}
		}
		mcMonthlySummary(
			workspaceIds: $mcMonthlySummaryWorkspaceIds2
			filters: $mcMonthlySummaryFilters2
		) {
			date
			mcDetails {
				status
				count
			}
		}
	}
`;

class MonthlyOverviewGraph extends ProjectsGraphQl {
	constructor() {
		super();

		this.state = {
			isLoading: true,
			workspaceActiveFilter: '',
			workspacesFilters: [],
			monthActiveFilter: moment().format('MMMM').toLowerCase(),
			eventTypeActiveFilter: '',
			eventTypeFilters: [],
			isClicked: false,
			fullScreenChart: false,
			monthFilters: [
				{ key: 'january', name: 'January' },
				{ key: 'february', name: 'February' },
				{ key: 'march', name: 'March' },
				{ key: 'april', name: 'April' },
				{ key: 'may', name: 'May' },
				{ key: 'june', name: 'June' },
				{ key: 'july', name: 'July' },
				{ key: 'august', name: 'August' },
				{ key: 'september', name: 'September' },
				{ key: 'october', name: 'October' },
				{ key: 'november', name: 'November' },
				{ key: 'december', name: 'December' },
			],
			isPageLoading: false,
			shootsLineGraphData: {
				labels: _.map(new Array(moment().daysInMonth()).fill(0), (item, inx) => {
					return inx + 1;
				}),
				datasets: [
					{
						label: 'Shoots',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						//fill: false,
						borderColor: '#8F56DA',
						borderWidth: 1.07072,
						tension: 0.1,
					},
				],
			},
			expensesLineGraphData: {
				labels: _.map(new Array(moment().daysInMonth()).fill(0), (item, inx) => {
					return inx + 1;
				}),
				datasets: [
					{
						label: 'Total Expenses',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#8F56DA',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Approved Expenses',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#FECE24',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Unapproved Expenses',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#03A0FF',
						borderWidth: 1.07072,
						tension: 0.1,
					},
				],
			},
			assignedLineGraphData: {
				labels: _.map(new Array(moment().daysInMonth()).fill(0), (item, inx) => {
					return inx + 1;
				}),
				datasets: [
					{
						label: 'Assigned',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#FECE24',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Unassigned',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#03A0FF',
						borderWidth: 1.07072,
						tension: 0.1,
					},
				],
			},
			requirementLineGraphData: {
				labels: _.map(new Array(moment().daysInMonth()).fill(0), (item, inx) => {
					return inx + 1;
				}),
				datasets: [
					{
						label: 'CP',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#8F56DA',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'CT',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#FECE24',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'CV',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#03A0FF',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'TV',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#FE2C2B',
						borderWidth: 1.07072,
						tension: 0.1,
					},
				],
			},
			ledLineGraphData: {
				labels: _.map(new Array(moment().daysInMonth()).fill(0), (item, inx) => {
					return inx + 1;
				}),
				datasets: [
					{
						label: 'Shoots',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#8F56DA',
						borderWidth: 1.07072,
						tension: 0.1,
					},
				],
			},
			webLiveLineGraphData: {
				labels: _.map(new Array(moment().daysInMonth()).fill(0), (item, inx) => {
					return inx + 1;
				}),
				datasets: [
					{
						label: 'Shoots',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#8F56DA',
						borderWidth: 1.07072,
						tension: 0.1,
					},
				],
			},
			mcLineGraphData: {
				labels: _.map(new Array(moment().daysInMonth()).fill(0), (item, inx) => {
					return inx + 1;
				}),
				datasets: [
					{
						label: 'Assigned',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#FECE24',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Registered',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#03A0FF',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Copied',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#2ED83F',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Verified',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#482121',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Released',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#7B7B7B',
						borderWidth: 1.07072,
						tension: 0.1,
					},
					{
						label: 'Received',
						data: [],
						/* data: [
							13, 6, 33, 26, 33, 27, 29, 24, 0, 10, 9, 11, 29, 31, 50, 36, 15, 41, 36,
							37, 49, 25, 4, 8, 15, 0, 12, 10, 17, 4, 11,
						], */
						fill: false,
						borderColor: '#AD00FF',
						borderWidth: 1.07072,
						tension: 0.1,
					},
				],
			},
			crewMapdata: {
				CP: {
					role: 'photographer',
					subRole: 'candid',
				},
				TP: {
					role: 'photographer',
					subRole: 'traditional',
				},
				CV: {
					role: 'cinematographer',
					subRole: 'candid',
				},
				TV: {
					role: 'cinematographer',
					subRole: 'traditional',
				},
			},
			isMouseOut: false,
		};

		this.shootsChartReference = React.createRef();
		this.expensesChartReference = React.createRef();
		this.assignedChartReference = React.createRef();
		this.requirementChartReference = React.createRef();
		this.ledChartReference = React.createRef();
		this.webLiveChartReference = React.createRef();
		this.mcChartReference = React.createRef();

		this.chartRef = React.createRef();
	}

	componentDidMount = async () => {
		Chart.register({
			id: 'p2',
			afterDatasetsDraw: function (chart) {
				if (chart.tooltip._active && _.size(chart.tooltip._active) > 0) {
					var activePoint = chart.tooltip._active[0],
						ctx = chart.ctx,
						y_axis = chart.scales['y'],
						x_axis = chart.scales['x'],
						x = activePoint.element.x,
						y = activePoint.element.y,
						topY = y_axis.top,
						bottomY = y_axis.bottom,
						leftX = x_axis.left;
					// draw line
					ctx.save();
					ctx.beginPath();
					ctx.setLineDash([3.21, 3.21]);
					ctx.moveTo(x, topY);
					ctx.lineTo(x, bottomY);
					ctx.lineWidth = 1.07072;
					ctx.strokeStyle = '#07C';
					ctx.stroke();
					ctx.setLineDash([3.21, 3.21]);
					ctx.beginPath();
					ctx.moveTo(x, y);
					ctx.lineTo(leftX, y);
					ctx.lineWidth = 1.07072;
					ctx.strokeStyle = '#07C';
					ctx.stroke();
					ctx.restore();
				}
			},
		});
		Chart.register({
			id: 'p1',
			beforeEvent: (chart, args, pluginOptions) => {
				const event = args.event;
				if (event.type === 'mouseout') {
					if (_.size(chart.tooltip._active) > 0) {
						let index = chart.tooltip._active[0].index;
						setTimeout(() => {
							this.triggerTooltip(index);
						}, 200);
					}
					this.setState({ isMouseOut: true });
				}
				if (event.type === 'mousemove') {
					this.setState({
						isMouseOut: false,
					});
				}
			},
		});

		document.addEventListener('mousedown', this.handleMouseClick);

		let json = {
			vendorId: this.props.params.vendorID,
		};

		await this.getVendorsWorkspaces(getWorkspaces, json, 'modify-object');

		let queryParams = new URLSearchParams(this.props.locations.search);

		let json2 = {
			filters: {},
			mcMonthlySummaryFilters2: {},
		};

		if (_.size(queryParams.toString()) === 0) {
			queryParams.set('month', moment().format('MMMM').toLowerCase());
		}

		if (queryParams.has('eventType')) {
			queryParams.set('eventType', queryParams.get('eventType'));

			this.setState({
				eventTypeActiveFilter: queryParams.get('eventType'),
			});
		}

		if (queryParams.has('workspaceIds')) {
			queryParams.set('workspaceIds', queryParams.get('workspaceIds'));

			json2.workspaceIds = [queryParams.get('workspaceIds')];
			json2.mcMonthlySummaryFilters2 = [queryParams.get('workspaceIds')];

			this.setState({
				workspaceActiveFilter: queryParams.get('workspaceIds'),
			});
		}

		if (queryParams.has('month')) {
			queryParams.set('month', queryParams.get('month'));

			json2.filters = {
				startDate: parseInt(
					moment().month(queryParams.get('month')).startOf('month').format('YYYYMMDD'),
				),
				endDate: parseInt(
					moment().month(queryParams.get('month')).endOf('month').format('YYYYMMDD'),
				),
			};
			json2.mcMonthlySummaryFilters2 = {
				startDate: parseInt(
					moment().month(queryParams.get('month')).startOf('month').format('YYYYMMDD'),
				),
				endDate: parseInt(
					moment().month(queryParams.get('month')).endOf('month').format('YYYYMMDD'),
				),
			};

			this.setState({
				monthActiveFilter: queryParams.get('month'),
			});
		} else {
			json2.filters = {
				startDate: parseInt(moment().startOf('month').format('YYYYMMDD')),
				endDate: parseInt(moment().endOf('month').format('YYYYMMDD')),
			};
			json2.mcMonthlySummaryFilters2 = {
				startDate: parseInt(moment().startOf('month').format('YYYYMMDD')),
				endDate: parseInt(moment().endOf('month').format('YYYYMMDD')),
			};
		}

		this.props.navigate(
			`/${this.props.params.vendorID}/monthly-overview-graph${
				_.size(queryParams.toString()) === 0 ? '' : `?${queryParams.toString()}`
			}`,
		);

		this.getMonthlyOverview(getMonthlyOverview, json2, true);
	};

	componentWillUnmount = () => {
		document.removeEventListener('mousedown', this.handleMouseClick);
	};

	handleMouseClick = (e) => {
		if (this.state.isMouseOut === true) {
			this.triggerExitTooltip();
		}
	};

	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]:
					type === 'month' ? moment().format('MMMM').toLowerCase() : '',
				isPageLoading: type === 'eventType' ? false : true,
			},
			() => {
				let queryParams = new URLSearchParams(this.props.locations.search);

				queryParams.delete('eventType');

				this.props.navigate(
					`/${this.props.params.vendorID}/monthly-overview-graph${
						_.size(queryParams.toString()) === 0 ? '' : `?${queryParams.toString()}`
					}`,
				);
				if (type !== 'eventType') {
					this.fetchFilteredOverview();
				} else {
					let shootsLineGraphData = _.cloneDeep(this.state.shootsLineGraphData);
					shootsLineGraphData.datasets[0].data = [];
					_.forEach(
						new Array(moment().month(this.state.monthActiveFilter).daysInMonth()).fill(
							0,
						),
						(date, index) => {
							let day = parseInt(
								moment()
									.month(this.state.monthActiveFilter)
									.date(index + 1)
									.format('YYYYMMDD'),
							);

							let found = _.filter(this.state.monthlyOverview.events, {
								date: day,
							});

							if (_.size(found) > 0) {
								_.forEach(found, (item, inx) => {
									if (inx === 0) {
										shootsLineGraphData.datasets[0].data.push(item.totalEvents);
									} else {
										shootsLineGraphData.datasets[0].data[index] +=
											item.totalEvents;
									}
								});
							} else {
								shootsLineGraphData.datasets[0].data.push(0);
							}
						},
					);
					this.setState({
						shootsLineGraphData,
					});
				}
			},
		);
	};

	applyFilter = async (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]:
					type === 'month' && filter === ''
						? moment().format('MMMM').toLowerCase()
						: filter,
				isPageLoading: type === 'eventType' ? false : true,
			},
			async () => {
				if (type === 'month') {
					let queryParams = new URLSearchParams(this.props.locations.search);

					queryParams.delete('eventType');

					await this.props.navigate(
						`/${this.props.params.vendorID}/monthly-overview-graph${
							_.size(queryParams.toString()) === 0 ? '' : `?${queryParams.toString()}`
						}`,
					);

					let labels = _.map(
						new Array(moment().month(this.state.monthActiveFilter).daysInMonth()).fill(
							0,
						),
						(item, inx) => {
							return inx + 1;
						},
					);
					let shootsLineGraphData = _.cloneDeep(this.state.shootsLineGraphData);
					shootsLineGraphData = {
						...shootsLineGraphData,
						labels: labels,
					};

					let expensesLineGraphData = _.cloneDeep(this.state.expensesLineGraphData);
					expensesLineGraphData = {
						...expensesLineGraphData,
						labels: labels,
					};

					let assignedLineGraphData = _.cloneDeep(this.state.assignedLineGraphData);
					assignedLineGraphData = {
						...assignedLineGraphData,
						labels: labels,
					};

					let requirementLineGraphData = _.cloneDeep(this.state.requirementLineGraphData);
					requirementLineGraphData = {
						...requirementLineGraphData,
						labels: labels,
					};

					let ledLineGraphData = _.cloneDeep(this.state.ledLineGraphData);
					ledLineGraphData = {
						...ledLineGraphData,
						labels: labels,
					};

					let webLiveLineGraphData = _.cloneDeep(this.state.webLiveLineGraphData);
					webLiveLineGraphData = {
						...webLiveLineGraphData,
						labels: labels,
					};

					this.setState(
						{
							shootsLineGraphData,
							expensesLineGraphData,
							assignedLineGraphData,
							requirementLineGraphData,
							ledLineGraphData,
							webLiveLineGraphData,
						},
						() => {
							this.fetchFilteredOverview();
						},
					);
				} else if (type === 'workspace') {
					let queryParams = new URLSearchParams(this.props.locations.search);

					queryParams.delete('eventType');

					await this.props.navigate(
						`/${this.props.params.vendorID}/monthly-overview-graph${
							_.size(queryParams.toString()) === 0 ? '' : `?${queryParams.toString()}`
						}`,
					);
					this.fetchFilteredOverview();
				} else if (type === 'eventType') {
					let shootsLineGraphData = _.cloneDeep(this.state.shootsLineGraphData);

					if (_.size(this.state.eventTypeActiveFilter) > 0) {
						let queryParams = new URLSearchParams(this.props.locations.search);

						queryParams.set('eventType', this.state.eventTypeActiveFilter);

						await this.props.navigate(
							`/${this.props.params.vendorID}/monthly-overview-graph${
								_.size(queryParams.toString()) === 0
									? ''
									: `?${queryParams.toString()}`
							}`,
						);

						shootsLineGraphData.datasets[0].data = [];
						let filteredEvents = _.filter(this.state.monthlyOverview.events, {
							eventType: this.state.eventTypeActiveFilter,
						});
						_.forEach(
							new Array(
								moment().month(this.state.monthActiveFilter).daysInMonth(),
							).fill(0),
							(date, index) => {
								let day = parseInt(
									moment()
										.month(this.state.monthActiveFilter)
										.date(index + 1)
										.format('YYYYMMDD'),
								);

								let found = _.find(filteredEvents, { date: day });

								if (found) {
									shootsLineGraphData.datasets[0].data.push(found.totalEvents);
								} else {
									shootsLineGraphData.datasets[0].data.push(0);
								}
							},
						);
					} else {
						let queryParams = new URLSearchParams(this.props.locations.search);

						queryParams.delete('eventType');

						await this.props.navigate(
							`/${this.props.params.vendorID}/monthly-overview-graph${
								_.size(queryParams.toString()) === 0
									? ''
									: `?${queryParams.toString()}`
							}`,
						);
						shootsLineGraphData.datasets[0].data = [];
						_.forEach(
							new Array(
								moment().month(this.state.monthActiveFilter).daysInMonth(),
							).fill(0),
							(date, index) => {
								let day = parseInt(
									moment()
										.month(this.state.monthActiveFilter)
										.date(index + 1)
										.format('YYYYMMDD'),
								);

								let found = _.filter(this.state.monthlyOverview.events, {
									date: day,
								});

								if (_.size(found) > 0) {
									_.forEach(found, (item, inx) => {
										if (inx === 0) {
											shootsLineGraphData.datasets[0].data.push(
												item.totalEvents,
											);
										} else {
											shootsLineGraphData.datasets[0].data[index] +=
												item.totalEvents;
										}
									});
								} else {
									shootsLineGraphData.datasets[0].data.push(0);
								}
							},
						);
					}
					this.setState({
						shootsLineGraphData,
					});
				}
			},
		);
	};

	fetchFilteredOverview = () => {
		let queryParams = new URLSearchParams(this.props.locations.search);

		queryParams.delete('workspaceIds');
		queryParams.delete('month');

		if (_.size(this.state.workspaceActiveFilter) > 0)
			queryParams.set('workspaceIds', this.state.workspaceActiveFilter);

		if (_.size(this.state.monthActiveFilter) > 0)
			queryParams.set('month', this.state.monthActiveFilter);

		this.props.navigate(
			`/${this.props.params.vendorID}/monthly-overview-graph${
				_.size(queryParams.toString()) === 0 ? '' : `?${queryParams.toString()}`
			}`,
		);

		let json = {
			filters: {
				startDate: parseInt(
					moment()
						.month(this.state.monthActiveFilter)
						.startOf('month')
						.format('YYYYMMDD'),
				),
				endDate: parseInt(
					moment().month(this.state.monthActiveFilter).endOf('month').format('YYYYMMDD'),
				),
			},
			mcMonthlySummaryFilters2: {
				startDate: parseInt(
					moment()
						.month(this.state.monthActiveFilter)
						.startOf('month')
						.format('YYYYMMDD'),
				),
				endDate: parseInt(
					moment().month(this.state.monthActiveFilter).endOf('month').format('YYYYMMDD'),
				),
			},
		};

		if (_.size(this.state.workspaceActiveFilter) > 0) {
			json.workspaceIds = [this.state.workspaceActiveFilter];
			json.mcMonthlySummaryWorkspaceIds2 = [this.state.workspaceActiveFilter];
		}

		this.getMonthlyOverview(getMonthlyOverview, json);
	};

	triggerTooltip = (index) => {
		let chart;
		let tooltip;
		let chartArea;

		/* chart = this.chartRef.current;

		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;

			if (
				this.state.fullScreenChart === 'shoots' ||
				this.state.fullScreenChart === 'led' ||
				this.state.fullScreenChart === 'weblive'
			) {
				tooltip.setActiveElements(
					[
						{
							datasetIndex: 0,
							index: index,
						},
					],
					{
						x: (chartArea.left + chartArea.right) / 2,
						y: (chartArea.top + chartArea.bottom) / 2,
					},
				);
			} else if (
				this.state.fullScreenChart === 'expenses' ||
				this.state.fullScreenChart === 'crew'
			) {
				tooltip.setActiveElements(
					[
						{
							datasetIndex: 0,
							index: index,
						},
						{
							datasetIndex: 1,
							index: index,
						},
						{
							datasetIndex: 2,
							index: index,
						},
					],
					{
						x: (chartArea.left + chartArea.right) / 2,
						y: chartArea.top + chartArea.bottom,
					},
				);
			} else if (this.state.fullScreenChart === 'requirement') {
				tooltip.setActiveElements(
					[
						{
							datasetIndex: 0,
							index: index,
						},
						{
							datasetIndex: 1,
							index: index,
						},
						{
							datasetIndex: 2,
							index: index,
						},
						{
							datasetIndex: 3,
							index: index,
						},
					],
					{
						x: (chartArea.left + chartArea.right) / 2,
						y: chartArea.top + chartArea.bottom,
					},
				);
			} else if (this.state.fullScreenChart === 'mc') {
				tooltip.setActiveElements(
					[
						{
							datasetIndex: 0,
							index: index,
						},
						{
							datasetIndex: 1,
							index: index,
						},
						{
							datasetIndex: 2,
							index: index,
						},
						{
							datasetIndex: 3,
							index: index,
						},
						{
							datasetIndex: 4,
							index: index,
						},
						{
							datasetIndex: 5,
							index: index,
						},
						{
							datasetIndex: 6,
							index: index,
						},
					],
					{
						x: (chartArea.left + chartArea.right) / 2,
						y: chartArea.top + chartArea.bottom,
					},
				);
			}

			chart.update();
		} */

		chart = this.shootsChartReference.current;
		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;
			tooltip.setActiveElements(
				[
					{
						datasetIndex: 0,
						index: index,
					},
				],
				{
					x: (chartArea.left + chartArea.right) / 2,
					y: (chartArea.top + chartArea.bottom) / 2,
				},
			);
			chart.update();
		}

		chart = this.expensesChartReference.current;
		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;
			tooltip.setActiveElements(
				[
					{
						datasetIndex: 0,
						index: index,
					},
					{
						datasetIndex: 1,
						index: index,
					},
					{
						datasetIndex: 2,
						index: index,
					},
				],
				{
					x: (chartArea.left + chartArea.right) / 2,
					y: chartArea.top + chartArea.bottom,
				},
			);
			chart.update();
		}

		chart = this.assignedChartReference.current;
		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;
			tooltip.setActiveElements(
				[
					{
						datasetIndex: 0,
						index: index,
					},
					{
						datasetIndex: 1,
						index: index,
					},
				],
				{
					x: (chartArea.left + chartArea.right) / 2,
					y: chartArea.top + chartArea.bottom,
				},
			);
			chart.update();
		}

		chart = this.requirementChartReference.current;
		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;
			tooltip.setActiveElements(
				[
					{
						datasetIndex: 0,
						index: index,
					},
					{
						datasetIndex: 1,
						index: index,
					},
					{
						datasetIndex: 2,
						index: index,
					},
					{
						datasetIndex: 3,
						index: index,
					},
				],
				{
					x: (chartArea.left + chartArea.right) / 2,
					y: chartArea.top + chartArea.bottom,
				},
			);
			chart.update();
		}

		chart = this.ledChartReference.current;
		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;
			tooltip.setActiveElements(
				[
					{
						datasetIndex: 0,
						index: index,
					},
				],
				{
					x: (chartArea.left + chartArea.right) / 2,
					y: (chartArea.top + chartArea.bottom) / 2,
				},
			);
			chart.update();
		}

		chart = this.webLiveChartReference.current;
		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;
			tooltip.setActiveElements(
				[
					{
						datasetIndex: 0,
						index: index,
					},
				],
				{
					x: (chartArea.left + chartArea.right) / 2,
					y: (chartArea.top + chartArea.bottom) / 2,
				},
			);
			chart.update();
		}

		chart = this.mcChartReference.current;
		if (chart) {
			tooltip = chart.tooltip;
			chartArea = chart.chartArea;
			tooltip.setActiveElements(
				[
					{
						datasetIndex: 0,
						index: index,
					},
					{
						datasetIndex: 1,
						index: index,
					},
					{
						datasetIndex: 2,
						index: index,
					},
					{
						datasetIndex: 3,
						index: index,
					},
					{
						datasetIndex: 4,
						index: index,
					},
					{
						datasetIndex: 5,
						index: index,
					},
				],
				{
					x: (chartArea.left + chartArea.right) / 2,
					y: (chartArea.top + chartArea.bottom) / 2,
				},
			);
			chart.update();
		}
	};

	triggerExitTooltip = () => {
		let chart;
		let tooltip;

		chart = this.chartRef.current;

		if (chart) {
			tooltip = chart.tooltip;
			tooltip.setActiveElements([]);
			chart.update();
		}

		chart = this.shootsChartReference.current;
		tooltip = chart.tooltip;
		tooltip.setActiveElements([]);
		chart.update();

		chart = this.expensesChartReference.current;
		tooltip = chart.tooltip;
		tooltip.setActiveElements([]);
		chart.update();

		chart = this.assignedChartReference.current;
		tooltip = chart.tooltip;
		tooltip.setActiveElements([]);
		chart.update();

		chart = this.requirementChartReference.current;
		tooltip = chart.tooltip;
		tooltip.setActiveElements([]);
		chart.update();

		chart = this.ledChartReference.current;
		tooltip = chart.tooltip;
		tooltip.setActiveElements([]);
		chart.update();

		chart = this.webLiveChartReference.current;
		tooltip = chart.tooltip;
		tooltip.setActiveElements([]);
		chart.update();

		chart = this.mcChartReference.current;
		tooltip = chart.tooltip;
		tooltip.setActiveElements([]);
		chart.update();
	};

	/* getOrCreateTooltip = (chart) => {
		let tooltipEl = chart.canvas.parentNode.querySelector('div');

		if (!tooltipEl) {
			tooltipEl = document.createElement('div');
			tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
			tooltipEl.style.borderRadius = '3px';
			tooltipEl.style.color = 'white';
			tooltipEl.style.opacity = 1;
			tooltipEl.style.pointerEvents = 'none';
			tooltipEl.style.position = 'absolute';
			tooltipEl.style.transform = 'translate(-50%, 0)';
			tooltipEl.style.transition = 'all .1s ease';

			const table = document.createElement('table');
			table.style.margin = '0px';

			tooltipEl.appendChild(table);
			chart.canvas.parentNode.appendChild(tooltipEl);
		}

		return tooltipEl;
	};

	externalTooltipHandler = (context) => {
		// Tooltip Element
		const { chart, tooltip } = context;
		const tooltipEl = this.getOrCreateTooltip(chart);

		// Hide if no tooltip
		if (tooltip.opacity === 0) {
			tooltipEl.style.opacity = 0;
			return;
		}

		// Set Text
		if (tooltip.body) {
			const titleLines = tooltip.title || [];
			const bodyLines = tooltip.body.map((b) => b.lines);

			const tableHead = document.createElement('thead');

			titleLines.forEach((title) => {
				const tr = document.createElement('tr');
				tr.style.borderWidth = 0;

				const th = document.createElement('th');
				th.style.borderWidth = 0;
				const text = document.createTextNode(title);

				th.appendChild(text);
				tr.appendChild(th);
				tableHead.appendChild(tr);
			});

			const tableBody = document.createElement('tbody');
			bodyLines.forEach((body, i) => {
				const colors = tooltip.labelColors[i];

				const span = document.createElement('span');
				span.style.background = colors.backgroundColor;
				span.style.borderColor = colors.borderColor;
				span.style.borderWidth = '2px';
				span.style.marginRight = '10px';
				span.style.height = '10px';
				span.style.width = '10px';
				span.style.display = 'inline-block';

				const tr = document.createElement('tr');
				tr.style.backgroundColor = 'inherit';
				tr.style.borderWidth = 0;

				const td = document.createElement('td');
				td.style.borderWidth = 0;

				const text = document.createTextNode(body);

				td.appendChild(span);
				td.appendChild(text);
				tr.appendChild(td);
				tableBody.appendChild(tr);
			});

			const tableRoot = tooltipEl.querySelector('table');

			// Remove old children
			while (tableRoot.firstChild) {
				tableRoot.firstChild.remove();
			}

			// Add new children
			tableRoot.appendChild(tableHead);
			tableRoot.appendChild(tableBody);
		}

		const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

		// Display, position, and set styles for font
		tooltipEl.style.opacity = 1;
		tooltipEl.style.left = positionX + tooltip.caretX + 'px';
		tooltipEl.style.top = positionY + tooltip.caretY + 'px';
		tooltipEl.style.font = tooltip.options.bodyFont.string;
		tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
	}; */

	/* exitFullScreen = () => {
		this.setState({
			fullScreenChart: '',
			showDashboardGraphModal: false,
		});
	}; */

	toggleFullScreen = () => {
		this.setState(
			{
				fullScreenChart: !this.state.fullScreenChart,
				isClicked: false,
			},
			() => {
				let chart;
				let tooltip;

				chart = this.shootsChartReference.current;
				tooltip = chart.tooltip;
				tooltip.setActiveElements([]);
				chart.update();

				chart = this.expensesChartReference.current;
				tooltip = chart.tooltip;
				tooltip.setActiveElements([]);
				chart.update();

				chart = this.assignedChartReference.current;
				tooltip = chart.tooltip;
				tooltip.setActiveElements([]);
				chart.update();

				chart = this.requirementChartReference.current;
				tooltip = chart.tooltip;
				tooltip.setActiveElements([]);
				chart.update();

				chart = this.ledChartReference.current;
				tooltip = chart.tooltip;
				tooltip.setActiveElements([]);
				chart.update();

				chart = this.webLiveChartReference.current;
				tooltip = chart.tooltip;
				tooltip.setActiveElements([]);
				chart.update();

				chart = this.mcChartReference.current;
				tooltip = chart.tooltip;
				tooltip.setActiveElements([]);
				chart.update();
			},
		);
	};

	toggleIsClicked = () => {
		this.setState({
			isClicked: !this.state.isClicked,
		});
	};

	render() {
		//Line Chart Options
		let lineChartOptions = {
			maintainAspectRatio: this.state.fullScreenChart === true ? false : true,
			aspectRatio: 3.34,
			responsive: true,
			//normalized: true,
			animation: false,
			type: 'derivedLine',
			plugins: {
				legend: {
					display: false,
					labels: {
						font: {
							size: 6.4243,
							family: 'Inter',
						},
					},
				},
				tooltip: {
					//enabled: false,
					//position: 'nearest',
					//external: this.externalTooltipHandler,
					//xAlign: 'left',
					//yAlign: 'center',
					multiKeyBackground: 'rgba(0, 0, 0, 0)',
					callbacks: {
						title: (context) => {
							let title = context[0].label;
							return (
								title +
								` ${_.capitalize(this.state.monthActiveFilter.slice(0, 3))} ` +
								moment().format('YYYY')
							);
						},
						labelColor: function (context) {
							return {
								borderColor: 'rgba(0,0,0,0)',
								backgroundColor: context.dataset.borderColor,
							};
						},
					},
				},
			},
			onClick: (e, elements) => {
				if (_.size(elements) > 0) {
					this.toggleIsClicked();
					this.triggerTooltip(elements[0].index);
				} else {
					this.setState({
						isClicked: false,
					});
				}
			},
			onHover: (e, elements) => {
				e.native.target.style.cursor = elements[0] ? 'pointer' : 'default';
				if (_.has(elements[0], 'index')) {
					this.triggerTooltip(elements[0].index);
				}
			},
			events: this.state.isClicked === true ? ['click'] : ['click', 'mousemove', 'mouseout'],
			interaction: {
				mode: 'x',
				intersect: false,
			},
			elements: {
				point: {
					backgroundColor: '#FFFFFF',
					hoverBackgroundColor: '#FFFFFF',
					radius: 1.605,
					hoverRadius: 3,
				},
			},
			scales: {
				x: {
					offset: true,
					ticks: {
						color: '#FFFFFF',
						padding: 9.1,
						font: {
							size: 6.4243,
							weight: 'normal',
							family: 'Inter',
						},
						callback: (value) => {
							if (value < parseInt(9)) {
								return `0${value + 1}`;
							} else {
								return value + 1;
							}
						},
					},
					grid: {
						tickLength: 0,
						borderColor: '#383838',
						lineWidth: 1.07072,
						borderWidth: 1.07072,
						display: true,
						drawBorder: true,
						color: 'rgba(83, 83, 83, 0.2)',
					},
					border: {
						display: true,
						color: '#535353',
						width: 1.07072,
						dash: [3.21, 3.21],
					},
				},
				y: {
					beginAtZero: true,
					ticks: {
						beginAtZero: true,
						align: 'end',
						color: '#ffffff',
						padding: 7,
						font: {
							size: 6.4243,
							weight: 'normal',
							family: 'Inter',
						},
						callback: (value) => {
							if (value === 0) {
								return '';
							} else if (value >= 1000 && value <= 100000) {
								return `${parseInt(value / 1000)} k`;
							} else if (value > 100000) {
								return `${parseInt(value / 100000)} Lac`;
							} else {
								return value;
							}
						},
					},

					grid: {
						tickColor: 'transparent',
						lineWidth: 1.07072,
						display: false,
						drawBorder: true,
						borderWidth: 1.07072,
						color: 'rgba(83, 83, 83, 0.2)',
					},
					border: {
						display: true,
						color: '#535353',
						width: 1.07072,
					},
				},
			},
		};

		return (
			<div className="layout-wrapper">
				{this.state.isLoading === true ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						<div className="searchContainer">
							<div className="shoots-header-filters-container">
								<Filter
									type={'month'}
									version="v2"
									label={'Month'}
									filters={this.state.monthFilters}
									activeFilter={this.state.monthActiveFilter}
									clearSelection={(e) => {
										this.handleclearSelection(e, 'month');
									}}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'workspace'}
									label={'Workspaces'}
									version="v2"
									filters={this.state.workspacesFilters}
									activeFilter={this.state.workspaceActiveFilter}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'workspace')
									}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'eventType'}
									version="v2"
									label={'Event Type'}
									filters={this.state.eventTypeFilters}
									activeFilter={this.state.eventTypeActiveFilter}
									clearSelection={(e) => {
										this.handleclearSelection(e, 'eventType');
									}}
									isMultipleSelectable={false}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
							</div>
						</div>
						<div className="monthly-dashboard-container">
							{this.state.isPageLoading === true ? (
								<LoadingBar />
							) : (
								<>
									<div
										className={
											'graph-contianer ' +
											(this.state.fullScreenChart === true
												? 'full-screen'
												: '')
										}
									>
										<div className="grap-top-container">
											<div className="left-graph-item-container">
												<div className="left-graph-item">
													<span className="tag-box purple"></span>
													<span>Shoots</span>
												</div>
											</div>
											<div
												className="graph-right-icon"
												onClick={() => {
													this.toggleFullScreen();
													/* this.setState({
														fullScreenChart: 'shoots',
														showDashboardGraphModal: true,
													}); */
												}}
											>
												<FullScreen />
											</div>
										</div>
										<div className="graph-bottom-container">
											<Line
												ref={this.shootsChartReference}
												options={lineChartOptions}
												data={this.state.shootsLineGraphData}
											/>
										</div>
									</div>
									<div
										className={
											'graph-contianer ' +
											(this.state.fullScreenChart === true
												? 'full-screen'
												: '')
										}
									>
										<div className="grap-top-container">
											<div className="left-graph-item-container">
												<div className="left-graph-item">
													<span className="tag-box purple"></span>
													<span>Total Expenses</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box yellow"></span>
													<span>Approved Expenses</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box blue"></span>
													<span>Unapproved Expenses</span>
												</div>
											</div>
											<div
												className="graph-right-icon"
												onClick={
													() => this.toggleFullScreen()
													/* this.setState({
														fullScreenChart: 'expenses',
														showDashboardGraphModal: true,
													}); */
												}
											>
												<FullScreen />
											</div>
										</div>
										<div className="graph-bottom-container">
											<Line
												ref={this.expensesChartReference}
												options={lineChartOptions}
												data={this.state.expensesLineGraphData}
											/>
										</div>
									</div>
									<div
										className={
											'graph-contianer ' +
											(this.state.fullScreenChart === true
												? 'full-screen'
												: '')
										}
									>
										<div className="grap-top-container">
											<div className="left-graph-item-container">
												<div className="left-graph-item">
													<span className="tag-box yellow"></span>
													<span>Assigned</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box blue"></span>
													<span>Unassigned</span>
												</div>
											</div>
											<div
												className="graph-right-icon"
												onClick={
													() => this.toggleFullScreen()
													/* this.setState({
														fullScreenChart: 'crew',
														showDashboardGraphModal: true,
													}); */
												}
											>
												<FullScreen />
											</div>
										</div>
										<div className="graph-bottom-container">
											<Line
												ref={this.assignedChartReference}
												options={lineChartOptions}
												data={this.state.assignedLineGraphData}
											/>
										</div>
									</div>
									<div
										className={
											'graph-contianer ' +
											(this.state.fullScreenChart === true
												? 'full-screen'
												: '')
										}
									>
										<div className="grap-top-container">
											<div className="left-graph-item-container">
												<div className="left-graph-item">
													<span>Requirement</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box purple"></span>
													<span>CP</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box yellow"></span>
													<span>TP</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box blue"></span>
													<span>CV</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box red"></span>
													<span>TV</span>
												</div>
											</div>
											<div
												className="graph-right-icon"
												onClick={
													() => this.toggleFullScreen()
													/* this.setState({
														fullScreenChart: 'requirement',
														showDashboardGraphModal: true,
													}); */
												}
											>
												<FullScreen />
											</div>
										</div>
										<div className="graph-bottom-container">
											<Line
												ref={this.requirementChartReference}
												options={lineChartOptions}
												data={this.state.requirementLineGraphData}
											/>
										</div>
									</div>
									<div
										className={
											'graph-contianer ' +
											(this.state.fullScreenChart === true
												? 'full-screen'
												: '')
										}
									>
										<div className="grap-top-container">
											<div className="left-graph-item-container">
												<div className="left-graph-item">
													<span className="tag-box purple"></span>
													<span>LED Walls</span>
												</div>
											</div>
											<div
												className="graph-right-icon"
												onClick={
													() => this.toggleFullScreen()
													/* this.setState({
														fullScreenChart: 'led',
														showDashboardGraphModal: true,
													}); */
												}
											>
												<FullScreen />
											</div>
										</div>
										<div className="graph-bottom-container">
											<Line
												ref={this.ledChartReference}
												options={lineChartOptions}
												data={this.state.ledLineGraphData}
											/>
										</div>
									</div>
									<div
										className={
											'graph-contianer ' +
											(this.state.fullScreenChart === true
												? 'full-screen'
												: '')
										}
									>
										<div className="grap-top-container">
											<div className="left-graph-item-container">
												<div className="left-graph-item">
													<span className="tag-box purple"></span>
													<span>Web Live</span>
												</div>
											</div>
											<div
												className="graph-right-icon"
												onClick={
													() => this.toggleFullScreen()
													/* this.setState({
														fullScreenChart: 'weblive',
														showDashboardGraphModal: true,
													}); */
												}
											>
												<FullScreen />
											</div>
										</div>
										<div className="graph-bottom-container">
											<Line
												ref={this.webLiveChartReference}
												options={lineChartOptions}
												data={this.state.webLiveLineGraphData}
											/>
										</div>
									</div>
									<div
										className={
											'graph-contianer ' +
											(this.state.fullScreenChart === true
												? 'full-screen'
												: '')
										}
									>
										<div className="grap-top-container">
											<div
												className="left-graph-item-container"
												style={{
													flexWrap: 'wrap',
												}}
											>
												<div className="left-graph-item">
													<span>MC Status</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box yellow"></span>
													<span>Assigned</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box blue"></span>
													<span>Registered</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box red"></span>
													<span>Copied</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box brown"></span>
													<span>Verified</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box gray"></span>
													<span>Released</span>
												</div>
												<div className="left-graph-item">
													<span className="tag-box pink"></span>
													<span>Received</span>
												</div>
											</div>
											<div
												className="graph-right-icon"
												onClick={
													() => this.toggleFullScreen()
													/* this.setState({
														fullScreenChart: 'mc',
														showDashboardGraphModal: true,
													}); */
												}
											>
												<FullScreen />
											</div>
										</div>
										<div className="graph-bottom-container">
											<Line
												ref={this.mcChartReference}
												options={lineChartOptions}
												data={this.state.mcLineGraphData}
											/>
										</div>
									</div>
								</>
							)}
						</div>
					</div>
				)}
				{/* {
					<DashboardGraphModal
						show={this.state.showDashboardGraphModal}
						close={this.exitFullScreen}
						handleClose={this.exitFullScreen}
						ref={this.chartRef}
						options={lineChartOptions}
						fullScreenChart={this.state.fullScreenChart}
						data={
							this.state.fullScreenChart === 'shoots'
								? this.state.shootsLineGraphData
								: this.state.fullScreenChart === 'expenses'
								? this.state.expensesLineGraphData
								: this.state.fullScreenChart === 'crew'
								? this.state.assignedLineGraphData
								: this.state.fullScreenChart === 'requirement'
								? this.state.requirementLineGraphData
								: this.state.fullScreenChart === 'led'
								? this.state.ledLineGraphData
								: this.state.fullScreenChart === 'weblive'
								? this.state.webLiveLineGraphData
								: this.state.fullScreenChart === 'mc'
								? this.state.mcLineGraphData
								: ''
						}
					/>
				} */}
			</div>
		);
	}
}

export default withRouter(MonthlyOverviewGraph);
